import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { Link } from '@lanl-web/lanl-components';
import DocumentIcon from '../../assets/svg/document.inline.svg';

import { getBoxInfo, getBoxURL } from '../../utils';

import './NavBox.scss';

export const NavBox = ({ className, primary_link, icon, section_links }) => {
  const classes = classNames('nav-box', className);

  const primaryLink = primary_link?.page ?? primary_link?.project ?? '#';
  const category = primaryLink?.title ?? '';
  const categoryLink = getBoxURL(primary_link) ?? '';
  const description = primaryLink?.page_description ?? '';

  return (
    <div className={classes}>
      <div className='content'>
        <h3 className='category'>{category}</h3>
        <p className='description'>{description}</p>
        <h5 className='in-this-section'>In This Section:</h5>
        <ul>
          {section_links.map(({ rl_links_id }, index) => {
            const { url, title } = getBoxInfo(rl_links_id);
            return (
              <li
                key={`${category}-section-link-${index}`}
                className='box-links'
              >
                <Link href={url}>{title}</Link>
              </li>
            );
          })}
        </ul>
      </div>
      <div className='category-icon'>{icon}</div>
      <div className='main-link'>
        <Link href={categoryLink}>{category}</Link>
      </div>
    </div>
  );
};

NavBox.defaultProps = {
  icon: <DocumentIcon />,
  links: [],
  section_links: [],
};

NavBox.propTypes = {
  primary_link: PropTypes.object.isRequired,
  section_links: PropTypes.array.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node,
};

export default NavBox;

export const fragNavBox = graphql`
  fragment boxNav on DirectusData_rl_components {
    nav_box {
      rl_box_nav_id(sort: "sort") {
        name
        sort
        primary_link {
          page {
            title
            page_description
            slug
            parent {
              slug
              parent {
                slug
              }
            }
          }
          project {
            title
            page_description
          }
        }
        section_links {
          rl_links_id {
            page {
              title
              slug
              parent {
                slug
                parent {
                  slug
                }
              }
            }
            project {
              title
              slug
            }
            anchor
            description
            display_name
            external
          }
        }
      }
    }
  }
`;
